<template>
  <div class="page-container">
    <!-- 头部容器 -->
    <div class="header-container">
      <!-- 标题 -->
      <div class="title-container">
        <span class="symbol-icon"></span>
        <span class="title-text">{{ $str.getKey('收益管理/配置规则') }}</span>
      </div>
      
    </div>

    <!-- 主体容器 -->
    <div class="main-container">
      <div class="create-panel">
        <el-form :model="createForm" class="create-form">
          <el-form-item :label="$str.getKey('收益管理/新建规则')" class="title-label">
            <div class="form-top-row">
              <el-button type="primary" @click="commitCreateRule" class="meter-feature-btn">{{ $str.getKey('收益管理/保存') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item :label="$str.getKey('收益管理/规则名称') + '：'">
            <!-- <el-input v-model="createForm.name" maxlength="10" disabled class="input-box"></el-input> -->
            <span>{{createForm.name}}</span>
          </el-form-item>
          <el-form-item :label="$str.getKey('收益管理/电表时段') + '：'">
            <div class="segment-list-container">
              <!-- 表格：时段列表 -->
              <el-scrollbar class="scroll-container" ref="createScrollbar">
                <div class="segment-list-wrapper">
                  <div v-for="(item, idx) in createForm.list" :key="item" class="segment-item">
                    <!-- 时间范围选择器 -->
                  <TimeRangeSelect
                    v-model="item.timeRange"
                    class="time-select-box"
                    :min-time="idx > 0 ? (createForm.list[idx - 1]?.timeRange?.[1] || '') : ''"
                    start="00:00"
                    step="00:30"
                    end="24:00"
                    :includeEnd="true"
                  />
                    <!-- 时段选择器 -->
                    <el-select v-model="item.type" :placeholder="$str.getKey('收益管理/请选择时段')" class="type-select-box">
                      <el-option v-for="item in origin.segmentMap" :key="item.value" :label="item.label()" :value="item.value" :disabled="item.disabled" />
                    </el-select>
                    <!-- 操作按钮 -->
                    <div class="operate-container">
                      <el-button class="btn-box" jd-type="add" @click="addSegmentItem(idx)">
                        <el-icon><Plus /></el-icon>
                      </el-button>
                      <el-button class="btn-box" jd-type="delete" @click="deleteSegmentItem(idx)">
                        <el-icon><Delete /></el-icon>
                      </el-button>
                    </div>
                  </div>
                </div>
              </el-scrollbar>
              <!-- 底部：新增按钮 -->
              <div class="bottom-add-container">
                <el-button jd-type="default" class="add-btn" @click="addSegmentItem(-1)">{{ $str.getKey('收益管理/新增') }}</el-button>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      
      <div class="rule-list-panel">
        <div class="title-container">{{ $str.getKey('收益管理/规则列表') }}</div>
        <div class="rule-table-container">
          <!-- <el-table :data="ruleList" stripe v-loading="loading" class="table-com"> -->
          <el-table :data="ruleList" stripe class="table-com">
            <el-table-column prop="name" :label="$str.getKey('收益管理/规则名称')" />
            <el-table-column prop="segments.sharp" :label="$str.getKey('收益管理/尖峰时段')">
              <template #default="{ row }">
                <div class="segment-cell">
                  <div v-for="item in row.segments.sharp" :key="item">{{item[0]}}-{{item[1]}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="segments.peak" :label="$str.getKey('收益管理/高峰时段')">
              <template #default="{ row }">
                <div class="segment-cell">
                  <div v-for="item in row.segments.peak" :key="item">{{item[0]}}-{{item[1]}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="segments.flat" :label="$str.getKey('收益管理/平时段')">
              <template #default="{ row }">
                <div class="segment-cell">
                  <div v-for="item in row.segments.flat" :key="item">{{item[0]}}-{{item[1]}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="segments.valley" :label="$str.getKey('收益管理/低谷时段')">
              <template #default="{ row }">
                <div class="segment-cell">
                  <div v-for="item in row.segments.valley" :key="item">{{item[0]}}-{{item[1]}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="segments.deepValley" :label="$str.getKey('收益管理/深谷时段')">
              <template #default="{ row }">
                <div class="segment-cell">
                  <div v-for="item in row.segments.deepValley" :key="item">{{item[0]}}-{{item[1]}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$str.getKey('收益管理/操作')" width="80">
              <template #default="{ row }">
                <div class="operate-cell">
                  <el-button size="small" jd-type="delete-text" link @click="handleOperate(row, 'delete')">{{ $str.getKey('收益管理/删除') }}</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

    </div>

  </div>
</template>

<script setup>
import { ref, reactive, computed, watch, nextTick, onMounted, watchEffect, inject } from "vue"
import dayjs from 'dayjs';
import { cloneDeep } from '@/utils';
import { queryMeterSegmentsInfo } from '../api/index.js';
import { isValidDate, isStartOfDay, transformStrToTime } from '@/utils/timeHelper/index.js';
import { v4 as uuidv4 } from 'uuid';
import TimeRangeSelect from './TimeRangeSelect.vue'

const $str = window.$str;

const emit = defineEmits(['ruleListChange']); // 声明：事件
const checkRuleIsUse = inject('checkRuleIsUse');

/** 接收父组件信息 */
const props = defineProps({
  year: {
    type: [Object, String],
    default: ''
  },
  adCode: {
    type: String,
    require:'',
  },
});

const createScrollbar = ref(null); // 引用：滚动条元素
const origin = {
  segmentMap: [
    {
      value: 'sharp',
      label: () => $str.getKey('收益管理/尖峰时段'),
    },
    {
      value: 'peak',
      label: () => $str.getKey('收益管理/高峰时段'),
    },
    {
      value: 'flat',
      label: () => $str.getKey('收益管理/平时段'),
    },
    {
      value: 'valley',
      label: () => $str.getKey('收益管理/低谷时段'),
    },
    {
      value: 'deepValley',
      label: () => $str.getKey('收益管理/深谷时段'),
    },
  ],
  segmentItem: {
    type: '', // 时段类型
    timeRange: ['', ''], // 起始时间-结束时间
  },
}


const createForm = reactive({
  name: '',
  list: []
});

const ruleList = ref([]);







/** 事件响应：监听&响应：【省市】【年份】的变化 */
watchEffect(() => {
  if (props.adCode && props.year) {
    initRuleListPanel(props.year, props.adCode);
  }
})



initPanel();


/** ====== [业务：功能方法] =================================================================== */
/** 初始化：面板 */
function initPanel() {
  // initRuleListPanel();
  initCreatePanel();
}


/** 初始化：规则列表的面板区域 */
async function initRuleListPanel(year, adCode) {
  const refList = [];
  
  await queryMeterSegmentsInfo(year, adCode).then(res => {
    if (Array.isArray(res?.data?.ruleList)) {
      res.data.ruleList.forEach(it => {
        const item = {
          name: it.name,
          id: generateUuid(8),
          segments: it.ruleInfo,
        }
        refList.push(item);
      });
    }
  });
  
  ruleList.value = refList;
  emit('ruleListChange', ruleList.value);
  initCreatePanel();
}


/** 初始化：创建规则的面板区域 */
function initCreatePanel() {
  createForm.name = generateRuleName();

  const newItem = cloneDeep(origin.segmentItem);
  newItem.timeRange[0] = '00:00';
  createForm.list = [newItem];
}


/** 新增：一个时段 */
function addSegmentItem(idx) {
  const newItem = cloneDeep(origin.segmentItem);
  const len = createForm.list.length;
  
  if (idx === -1) {
    if (len > 0) {
      newItem.timeRange[0] = createForm.list[len - 1].timeRange[1];
    }
    createForm.list.push(newItem);
  } else {
    newItem.timeRange[0] = createForm.list[idx].timeRange[1];
    createForm.list.splice(idx+1, 0, newItem);
  }
}


/** 删除：指定时段 */
function deleteSegmentItem(idx) {
  createForm.list.splice(idx, 1);
}


/** 提交：创建规则 */
function commitCreateRule() {
  const maxCount = 8;
  if (ruleList.value.length >= maxCount) {
    window.dispatchNotify({
      type: 'warning',
      message: $str.getKey('收益管理/规则数量已达到上限！')
    })
    return false;
  }


  let isOk = true;
  // 检查：规则名称不能为空
  isOk = !!createForm.name;
  if (!isOk) {
    window.dispatchNotify({
      type: 'warning',
      message: $str.getKey('收益管理/规则名称不能为空！')
    })
    return isOk;
  }


  // 检查：时段名称不能为空
  isOk = checkSegmentName(createForm.list);
  if (!isOk) {
    window.dispatchNotify({
      type: 'warning',
      message: $str.getKey('收益管理/时段名称不能为空！')
    })
    return isOk;
  }


  // 检查：时间为连续的24H
  isOk = checkTimeContinuity(createForm.list);
  if (!isOk) {
    window.dispatchNotify({
      type: 'warning',
      message: $str.getKey('收益管理/时间必须连续覆盖0~24小时！')
    })
    return isOk;
  }

  if (isOk) {
    addItemToRuleList();
    initCreatePanel();
    emit('ruleListChange', ruleList.value);
  }


}



/** 操作：规则列表操作栏的事件响应 */
function handleOperate(row, type) {
  // 删除
  if (type === 'delete') {
    if (checkRuleIsUse(row.id)) {
      window.dispatchNotify({
        type: 'warning',
        message: $str.getKey('收益管理/该规则正在使用中！')
      })
    } else {
      const idx = ruleList.value.findIndex(it => it.id === row.id);
      if (idx >= 0) {
        ruleList.value.splice(idx, 1);
        initCreatePanel();
        emit('ruleListChange', ruleList.value);
      }
    }
  }
}



/** ====== [辅助：功能方法] =================================================================== */
/** 校验：时段名称不能为空 */
function checkSegmentName(list) {
  const isOk = list.every(it => it.type);
  return isOk;
}


/** 校验：时间连续性 >>> 0~24h */
function checkTimeContinuity(list) {
  const len = list.length;
  // 1-处理时段小于1项的情况 ------
  if (len < 1) {
    return false;
  } else if (len === 1) {
    const isOk = list[0].timeRange[0] === '00:00' && list[0].timeRange[1] === '24:00';
    if (!isOk) {
      return false;
    }
  }

  // 1-处理时段大于1项的情况 ------

  // 获取时间列表：时间对象---非字符串时间
  const timeList = list.map((it, idx) => {
    const item = {
      st: transformStrToTime(it.timeRange[0]),
      et: transformStrToTime(it.timeRange[1]),
      originIdx: idx,
    }
    return item;
  });

  // 检查：是否存在无效时间段
  const hasInvalidTime = timeList.some(it => (!it.st || !it.et));
  if (hasInvalidTime) {
    return false;
  }

  // 升序排序
  timeList.sort((a,b) => {
    if (a.st.isBefore(b.st)) {
      return -1;
    } else {
      return 1;
    }
  });

  // 连续性判断
  for (let idx = 0; idx < len; idx++) {
    const st = timeList[idx].st;
    const et = timeList[idx].et;

    // 检查第一项
    if (idx === 0) {
      if (!isStartOfDay(st)) {
        return false;
      }
    }

    // 检查最后一项
    if (idx === (len - 1)) {
      // 一天的结束时刻，是第二天的开始时刻
      if (!isStartOfDay(et)) {
        return false;
      }
    }

    // 检查中间项
    if(idx < (len - 1)) {
      const it1et = et;
      const it2st = timeList[idx+1].st;
      if (!it1et.isSame(it2st, 'second')) {
        return false
      }
    }

  }

  return true;
}


/** 操作：向规则列表中，添加一条规则 */
function addItemToRuleList() {
  const newRule = {
    name: createForm.name,
    id: generateUuid(8),
    segments: {
      sharp: [], // 尖
      peak: [], // 峰
      flat: [], // 平
      valley: [], // 谷
      deepValley: [], // 深
    }
  }

  cloneDeep(createForm.list).forEach(it => {
    if (it.type === 'sharp') {
      newRule.segments.sharp.push(it.timeRange);
    }
    if (it.type === 'peak') {
      newRule.segments.peak.push(it.timeRange);
    }
    if (it.type === 'flat') {
      newRule.segments.flat.push(it.timeRange);
    }
    if (it.type === 'valley') {
      newRule.segments.valley.push(it.timeRange);
    }
    if (it.type === 'deepValley') {
      newRule.segments.deepValley.push(it.timeRange);
    }
  })
  ruleList.value.push(newRule);
}


/** 生成UUID */
function generateUuid(bit) {
  if (typeof(bit) === 'number' && bit >=4) {
    return uuidv4().replace(/-/g, '').substring(0, bit);
  } else {
    return uuidv4();
  }
}


/** 获取：自动生成规则名称 */
function generateRuleName() {
  // let idx = ruleList.value.length + 1;
  let idx = 1;
  let name = $str.getKey('收益管理/规则') + `${idx}`;
  while(ruleList.value.some(it => it.name === name)) {
    name = $str.getKey('收益管理/规则') + `${++idx}`;
  }
  return name;
}







</script>
<style lang="scss" scoped>
@import '../button-style.scss';

.page-container {
  --header-hight: 50px;
  & {
    width: 100%;
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(10px);
    padding: 10px;
  
    border-radius: 20px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .header-container {
    width: 100%;
    height: var(--header-hight);
    min-height: var(--header-hight);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-container {
      max-width: 50%;
      height: 100%;
      padding-left: 6px;
      display: flex;
      align-items: center;
      gap: 10px;

      .symbol-icon {
        width: 4px;
        height: 20px;
        background: #485e91;
      }
      .title-text {
        font-size: 18px;
      }
    }

  }


  .main-container {
    & {
      width: 100%;
      height: 450px;
      display: flex;
      gap: 10px;
    }

    .create-panel {
      & {
        // width: 700px;
        width: 44%;
        height: 100%;
        box-sizing: border-box;
        padding: 0px;
        background: var(--level2-bg-color);
        border: 1px solid rgba(0, 0, 0, 0.08);
        padding: 20px;
      }

      ::v-deep .create-form {
        .title-label {
          .el-form-item__label {
            width: 100%;
            font-size: 16px;
            font-weight: bold;
            color: rgba(46, 46, 46, 0.82);
            display: flex;
            justify-content: center;
          }
        }
        .form-top-row {
          width: 100%;
          display: flex;
          justify-content: flex-end;
        }
        .segment-list-container {
          // background-color: lime;
          width: 100%;
          max-height: 300px;
          /** 自适应：当前容器仅配置了最大高度，设置内容超出最大高度后-el-scroll组件自动滚动 */
          overflow: visible;
          display: grid;
          grid-template-rows: 1fr;
          .scroll-container {
            height: 100%;

            /* 单行布局不裁切：需要时允许横向滚动 */
            ::v-deep .el-scrollbar__wrap {
              overflow-x: auto;
            }

            .segment-list-wrapper {
              .segment-item {
                & {
                  min-height: 40px;
                  height: auto;
                  display: flex;
                  flex-wrap: nowrap;
                  align-items: center;
                  column-gap: 12px;
                  row-gap: 10px;
                  overflow: visible;
                }
                
                .time-select-box {
                  flex: 0 0 auto;
                  width: 260px;
                }

                .type-select-box {
                  flex: 0 0 120px;
                }

                .operate-container {
                  display: flex;
                  gap: 10px;
                  flex: 0 0 auto;
                  .btn-box {
                    width: 32px;
                    height: 32px;
                  }
                }
              }
            }
          }

          .bottom-add-container {
            width: 100%;
            margin-top: 10px;
            .add-btn {
              width: 100%;
            }
          }
        }

      }
    }

    .rule-list-panel {
      & {
        width: 56%;
        flex: 1;
        height: 100%;
        box-sizing: border-box;
        padding: 0px;
        background: var(--level2-bg-color);
        border: 1px solid rgba(0, 0, 0, 0.08);
        padding: 20px;

        display: flex;
        flex-direction: column;
        gap: 10px;

      }

      .title-container {
        width: 100%;
        // background-color: lime;
        color: rgba(46, 46, 46, 0.82);
        font-size: 16px;
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .rule-table-container {
        width: 100%;
        height: 100%;
        flex: 1;
        // background-color: lightcoral;
        display: grid;
        grid-template-rows: 1fr;
        overflow: scroll;

        .table-com {
          width: 100%;
          height: 100%;
        }



      }
    }




  }

  ::v-deep .el-scrollbar__bar.is-vertical {
    display: none;
    // opacity: 0.5;
  }

  /* `xy-time-range-select` 在浅色主题下的可视化适配 */
  ::v-deep .time-select-box {
    --xy-trs-bg: #ffffff;
    --xy-trs-text: rgba(46, 46, 46, 0.88);
    --xy-trs-border: rgba(0, 0, 0, 0.16);
  }

  ::v-deep .time-select-box input,
  ::v-deep .time-select-box .el-input__inner,
  ::v-deep .time-select-box .el-input__wrapper,
  ::v-deep .time-select-box .el-input {
    color: var(--xy-trs-text) !important;
  }

  ::v-deep .time-select-box .el-input__wrapper {
    background: var(--xy-trs-bg) !important;
    box-shadow: 0 0 0 1px var(--xy-trs-border) inset !important;
  }

  ::v-deep .time-select-box .el-input__inner::placeholder {
    color: rgba(46, 46, 46, 0.38);
  }
  
}
</style>
